import { css, styled } from "@mui/material";
import { colors } from "@procore/core-react";

export const VisibilityButton = styled("button")<{ disabled?: boolean }>(
    ({ disabled }) => css`
        cursor: ${disabled ? "not-allowed" : "pointer"};
        display: flex;
        align-items: center;
        padding: 4px;
        border: none;
        background: none;
        color: inherit;
        appearance: none;
        -webkit-appearance: none;
        border-radius: 4px;
        opacity: ${disabled ? 0.4 : 1};

        @media (hover: hover) and (pointer: fine) {
            &:hover {
                background-color: ${disabled ? "transparent" : colors.gray90};
            }
        }
    `,
);
